import { format } from "date-fns";

import { isBrowser } from "@/utils/isBrowser";

export type GetTimeZone = (data: {
  date: Date;
  format?: "short" | "long";
}) => string;

export type GetDate = (data: {
  date: Date;
  hideYear?: boolean;
  monthFormat?: "short" | "long";
}) => string;

export type GetDay = (data: {
  date: Date;
  dayFormat?: "short" | "long";
}) => string;

export const getDate: GetDate = ({
  date,
  hideYear = false,
  monthFormat = "long",
}) => {
  const options: Intl.DateTimeFormatOptions = {
    month: monthFormat,
    day: "numeric",
  };

  if (!hideYear) options.year = "numeric";
  return isBrowser()
    ? `${date.toLocaleString(navigator?.language, options)}`
    : "";
};

export const formatDayOfMonth = (day: number): string => {
  const suffix = (): string => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };
  return `${day}${suffix()}`;
};

export const getLocaleTimeWithAMPM = (date: Date): string =>
  isBrowser()
    ? date
        .toLocaleTimeString([], {
          hour12: true,
          hour: "numeric",
          minute: "2-digit",
        })
        .toLowerCase()
    : "";

export const getLocaleTimeZone: GetTimeZone = ({
  date,
  format = "short",
}): string =>
  isBrowser()
    ? date.toLocaleTimeString([], { timeZoneName: format })?.split(" ").pop() ||
      ""
    : "";

export const getDayOfTheWeek: GetDay = ({ date, dayFormat = "long" }) => {
  return dayFormat === "long" ? format(date, "EEEE") : format(date, "EEE");
};
